import { axiosInstance } from './xhrConfig';

export function fetchFaqSections() {
  return axiosInstance.get(`api/faq/section/`)
}

export function fetchFaqEntriesBySection(sectionId) {
  return axiosInstance.get(`api/faq/entry/?section=${sectionId}`)
}